var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSadFace = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.492 11.634c0-3.648-2.694-6.616-6.003-6.616-3.31 0-6 2.968-6 6.616m10.92.003c0-2.99-2.208-5.425-4.92-5.425-2.712 0-4.922 2.434-4.922 5.425",
  stroke: "#231F20",
  strokeWidth: 0.977
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 1.928,
  cy: 1.44,
  r: 1.44,
  fill: "#231F20"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.053,
  cy: 1.44,
  r: 1.44,
  fill: "#231F20"
})));
export default SvgSadFace;